import { PayloadAction } from "@reduxjs/toolkit";
import * as PartNumbersApi from "Data/API/PartNumbers";
import { ISelectOption } from "@clintonelec/react-storybook";
import { PartNumbersState } from "Data/Interfaces/PartNumbers";
import { createAppSlice } from "Data/Redux/Helpers";
import { selectToken } from "Data/Redux/Slices/User";
import { AppState } from "Data/Redux/Reducers";

const initialState: PartNumbersState = {
	partNumbers: []
};

// # region Selectors

const getParts = (state: PartNumbersState) => {
	return state.partNumbers;
};

const getPartNumbersOptions = (state: PartNumbersState) => {
	return state.partNumbers.map<ISelectOption>(partNumber => ({
		label: partNumber, value: partNumber
	}));
};

// # endregion

const partNumbersSlice = createAppSlice({
	name: "partNumbers",
	initialState,
	reducers: (builder) => ({
		getPartNumbersAction: builder.asyncThunk(async (payload: void, thunkApi): Promise<string[]> => {
			return PartNumbersApi.getPartNumbers(selectToken(thunkApi.getState() as AppState));
		}, {
			fulfilled: (state, action: PayloadAction<string[]>) => {
				state.partNumbers = action.payload;
			}
		})
	}),
	selectors: {
		selectParts: getParts,
		selectPartNumbersOptions: getPartNumbersOptions
	}
});

export default partNumbersSlice;

export const { getPartNumbersAction } = partNumbersSlice.actions;
export const { selectPartNumbersOptions, selectParts } = partNumbersSlice.selectors;
